import { CmsAnchorProps } from '~/types/Cms';

const CmsAnchor = ({ data }: CmsAnchorProps) => {
  if (!data.name) {
    return null;
  }

  return <div id={data.name} aria-hidden />;
};

export default CmsAnchor;
